import {
  GET_CATEGORY_LIST_RESPONSE,
  GET_CATEGORY_LIST_FOR_SUB_CATEGORY_RESPONSE,
  GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_RESPONSE,
  GET_CHILD_CATEGORY_LIST_RESPONSE,
  ADD_CATEGORY_RESPONSE,
  UPDATE_CATEGORY_BY_CATEGORY_ID_RESPONSE,
  UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_RESPONSE,
  DELETE_CATEGORY_BY_CATEGORY_ID_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  categoryApiResponse: null,
  categoryList: [],
  categoryData: [],
  categoryRecord: null,
};

const categoryMaster = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_CATEGORY_LIST_RESPONSE:
      case GET_CHILD_CATEGORY_LIST_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.categoryData = response.responseData;
        } else {
          draft.categoryData = [];
        }
        break;

      case GET_CATEGORY_LIST_FOR_PRODUCT_CATEGORY_RESPONSE:
      case GET_CATEGORY_LIST_FOR_SUB_CATEGORY_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.categoryList = response.responseData;
        } else {
          draft.categoryList = [];
        }
        break;

      case ADD_CATEGORY_RESPONSE:
        draft.categoryApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_CATEGORY_BY_CATEGORY_ID_RESPONSE:
        draft.categoryApiResponse = action.payload.apiResponse;
        break;

      case UPDATE_CATEGORY_STATUS_BY_CATEGORY_ID_RESPONSE:
        draft.categoryApiResponse = action.payload.apiResponse;
        break;

      case DELETE_CATEGORY_BY_CATEGORY_ID_RESPONSE:
        draft.categoryApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default categoryMaster;
